import { useTranslation } from 'react-i18next';
import IntegrationsTable from 'pages/integrations/components/integrationTable/IntegrationsTable';
import { IntegrationCategory } from 'models/InternalIntegrationSetting';
import TabHeader from '../../components/tabHeader/TabHeader';

const IntegrationsCleaningAndTurnoverTab = () => {
  const { t } = useTranslation();

  return (
    <section>
      <TabHeader
        tabName={t('pageIntegrations.tabNames.cleaning-and-turnover')}
      />
      <IntegrationsTable category={IntegrationCategory.CLEANING_AND_TURNOVER} />
    </section>
  );
};

export default IntegrationsCleaningAndTurnoverTab;
